<template>
    <ol class="relative space-y-5">
        <span class="absolute left-[14px] top-2 bottom-2 w-px bg-app" aria-hidden="true"></span>
        <li v-for="(a, i) in items" :key="a.id || i" class="relative ps-10">
            <span class="absolute left-[8px] top-3 h-3.5 w-3.5 rounded-full bg-brand-500 ring-4 ring-body"></span>
            <SessionCard :item="a" :event-location="eventLocation" :event-title="eventTitle" :hasCard="false" />
        </li>
    </ol>
</template>

<script setup lang="ts">
import { EventAgendaItem } from '~/types';
import SessionCard from './SessionCard.vue';

defineProps<{
    items: EventAgendaItem[];
    eventLocation?: string | null;
    eventTitle?: string;
}>();
</script>

<style scoped>
.bg-app {
    background-color: rgb(var(--core-app-border));
}
</style>
